import { useQuery } from '@apollo/client'

import { UNASSIGNED_CLIENTS, UnassignedClients } from './api'

export const useUnassignedClients = () => {
  const { data, loading } = useQuery<UnassignedClients>(UNASSIGNED_CLIENTS)

  return { clients: data?.unassignedClients.clients ?? [], isClientsLoading: loading }
}
